import {useIntl} from 'react-intl';
import React, {useCallback} from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';

import './CreateSegmentButton.scss';

interface CreateSegmentButtonProps {
  className?: string;
  disabled?: boolean;

  onBlur: () => void;
  onHover: () => void;
  onClick: () => void;
}

const CreateSegmentButton = ({
  className = '',
  disabled = false,

  onBlur,
  onHover,
  onClick,
}: CreateSegmentButtonProps) => {
  const intl = useIntl();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();

      if (!disabled) {
        onClick();
      }
    },
    [disabled, onClick]
  );

  return (
    <button
      disabled={disabled}
      className={`create-segment-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      onMouseLeave={onBlur}
      onMouseEnter={onHover}
      aria-label={intl.formatMessage({
        id: 'segmentedCreator.createSegmentButton.label',
      })}
    >
      <ChevronLeft fontSize="small" className="handler" />
      <ChevronRight fontSize="small" className="handler" />
    </button>
  );
};

export default CreateSegmentButton;
